import webserviceWrapper from "../_helpers/webserviceWrapper";

export const tarbookService={
    getUserProfileData,
    addEditPassword,
    AddEditProfileImage,
    GetDashboardDetails,
    GetTarbookInformation,
    GetShipBoardDetails,
    GetIndivisualShipDetail,
    GetTypeValues,
    AddEditShipBoardDetails,
    DeleteSelectedShipBoardDetails,
    SendChangeRequestMail,
}

function getUserProfileData(UserID,Grade){ 
    return webserviceWrapper.post(
        `Tarbook/GetProfileData`,
        {UserID,Grade}
    );
}

function addEditPassword(userName,password,UserID,Grade){
    return webserviceWrapper.post(
        `Tarbook/AddEditPassword`,
        {userName,password,UserID,Grade}
    );
}

function AddEditProfileImage(data){
    return webserviceWrapper.post(
        `Tarbook/AddEditProfileImage`,
        data
    );
}

function GetDashboardDetails(userID,grade){
    return webserviceWrapper.post(
        `Tarbook/GetDashboardDetails`,
        {userID,grade}
    );
}

function GetTarbookInformation(userID,grade){
    return webserviceWrapper.post(
        `Tarbook/GetTarbookInformation`,
        {userID,grade}
    );
}


function GetShipBoardDetails(userID){
    return webserviceWrapper.post(
        `Tarbook/GetShipBoardDetails`,
        {userID}
    );
}

function GetIndivisualShipDetail(shipDetailId){
    return webserviceWrapper.post(
        `Tarbook/GetIndivisualShipDetail`,
        {shipDetailId}
    );
}

function GetTypeValues(){
    return webserviceWrapper.get(
        `Tarbook/GetTypeValues`
    );
}

function AddEditShipBoardDetails(ShipBoardDetailsModel){
    return webserviceWrapper.post(
        `Tarbook/AddEditShipBoardDetails`,
        ShipBoardDetailsModel
    );
}

function DeleteSelectedShipBoardDetails(selectIdToDelete){
    return webserviceWrapper.post(
        `Tarbook/DeleteSelectedShipBoardDetails`,
        {selectIdToDelete}
    );
}

function SendChangeRequestMail(userName,value){
    return webserviceWrapper.post(
        `Tarbook/SendChangeRequestMail`,
        {userName,value}
    );
}